import BarbaView from 'abstractions/BarbaView'
import initLozad from 'controllers/init-lozad'

export default new BarbaView('about', {
  afterEnter: function ({ next }) {
    initLozad.call(this, next.container)
  }
})
